import { useState, useEffect } from "react";
import { getSoldOutProducts } from "../api/soldOutApi";

export const useSoldOutProducts = () => {
  const [soldOutData, setSoldOutData] = useState({});

  useEffect(() => {
    getSoldOutProducts().then((data) => {
      if (Array.isArray(data) && data.length) {
        const soldOutProductData = data.reduce((acc, product) => {
          if (product.productOsr) {
            acc[product.productOsr] = product;
          }
          return acc;
        }, {});

        setSoldOutData(soldOutProductData);
      }
    });
  }, []);

  return { soldOutData, setSoldOutData };
};
